import * as types from "./TimeZoneMasterActionType";

export const fetchMasterTimeZoneRequest = () => ({
  type: types.MASTER_TIMEZONE_REQUEST,
});

export const fetchMasterTimeZoneSuccess = (data) => ({
  type: types.MASTER_TIMEZONE_SUCCESS,
  payload: data,
});

export const fetchMasterTimeZoneFailure = (error) => ({
  type: types.MASTER_TIMEZONE_FAILURE,
  payload: error,
});